import {TweenLite, Power2} from 'tools/gsap';
import DescopedPromise from 'tools/descoped-promise';

class Animator {
    constructor(options = { }) {
        this.setDefaultOptions();

        Object.assign(this.options, options);
    }

    setDefaultOptions() {
        this.options = {
            elements: { },
            duration: 0.5,
            ease: Power2.easeInOut
        };
    }

    duration(duration) {
        if (duration === null) {
            duration = this.options.duration;
        }

        return duration;
    }

    element(element) {
        if (typeof element === 'string') {
            element = this.options.elements[element];
        }

        return element;
    }

    to(element, props, duration = null) {
        let promise = new DescopedPromise;

        // Make clone of object, including default ease
        props = Object.assign({
            ease: this.options.ease
        }, props);

        // Extract any passed onComplete options
        let onComplete = props.onComplete || null;

        // Override onComplete to custom handler
        props.onComplete = () => {
            // Execute the original onComplete, if specified
            if (onComplete) {
                onComplete();
            }

            // Resolve the descoped promise
            promise.resolve();
        };

        TweenLite.to(
            this.element(element),
            this.duration(duration),
            props
        );

        return promise;
    }

    fromTo(element, from, to, duration = null) {
        this.set(element, from);
        
        return this.to(element, to, duration);
    }

    animate(element, props, duration = null) {
        return this.to(element, props, duration);
    }

    set(element, props) {
        TweenLite.set(this.element(element), props);
    }

    kill() {
        TweenLite.killAll(false, true, false, false);
    }

    destroy() {
        this.setDefaultOptions();
    }
}

export default Animator;


// WEBPACK FOOTER //
// ./site/templates/resources/src/js/tools/animator.js